<template>
  <div id="app">
    <transition name="fade" mode="out-in" :key="ready">
    <div v-if="ready">
      <Header/>
      <!-- <keep-alive> -->
      <router-view></router-view>
      <!-- </keep-alive> -->
      <Footer/>
    </div>
    <Loader v-else />
    </transition>
    <Impressum />
    <Quellen />
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import Loader from '@/components/Loader.vue';
import Impressum from '@/components/Impressum.vue';
import Quellen from '@/components/Quellen.vue';
import Vue from 'vue';

export default {
  name: 'app',
  components: {
    Footer,
    Header,
    Loader,
    Impressum,
    Quellen,
  },

  computed: mapState([
    'ready',
  ]),

  data: () => ({
    loading: true,
    globals: {},
  }),

  watch: {
    ready(v, o) {
      const self = this;
      setTimeout(() => {
        self.resizeIframe();
      }, 1000);
    },
  },

  updated() {
    this.$nextTick(function () {
      this.resizeIframe();
    });
  },

  methods: {
    resizeIframe() {
      const IF = parent.document.getElementById('idIframe');
      if (IF) {
        const height = (document.body.scrollHeight) ? document.body.scrollHeight : 600;
        IF.height = height + 20;
      }
    },
    resizeMap() {
      const w = window;
      const d = document;
      const e = d.documentElement;
      const g = d.getElementsByTagName('body')[0];
      const x = w.innerWidth || e.clientWidth || g.clientWidth;
      const y = w.innerHeight || e.clientHeight || g.clientHeight;

      const isMobile = (x < 768);

      const globals = {
        x,
        y,
        isMobile,
      };

      Vue.prototype.$globals = globals;
      this.$root.tt = globals;
    },
  },
  mounted() {
    this.$store.dispatch('LOAD_APP_DATA');
    window.addEventListener('resize', this.resizeMap);
    this.resizeMap();
  },
};

</script>

<style scoped lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  max-width: 950px;
  width: 100%;
  margin: 0 auto;
}
</style>
